module.exports = __webpack_public_path__ + "media/images/sp/specials/common/store_utsunomiya-6d0407bbe077380fabfce1484b6dc441.jpg";